/**
 * Generates a URL-friendly slug from a name string.
 * Converts to lowercase, removes special characters, and replaces spaces with hyphens.
 * 
 * @param name - The name to convert to a slug
 * @returns A URL-friendly slug string
 * 
 * @example
 * generateSlug("My Organization Name") // "my-organization-name"
 * generateSlug("Test_Workspace 123") // "test-workspace-123"
 */
export function generateSlug(name: string): string {
  return name
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_-]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

